export const SET_TRAITS_DASHBOARD_SLUG = 'Traits / SET_TRAITS_DASHBOARD_SLUG';

export interface TraitsState {
  dashboardSlug: string;
}
